import type { RouteObject } from 'react-router';
import { RequirePermission } from '@/lib/auth';
import { lazyNamed } from '@/lib/lazy';

const ReportsPage = lazyNamed(() => import('./pages'), 'ReportsPage');
const ReportNewPage = lazyNamed(() => import('./pages'), 'ReportNewPage');
const ReportsSqlPage = lazyNamed(() => import('./pages'), 'ReportsSqlPage');
const ReportDetailPage = lazyNamed(() => import('./pages'), 'ReportDetailPage');

/**
 * Staff routes for features/reports. Paths are relative to /staff. Replace a placeholder by building the page in this folder
 * and pointing the lazy import at it; keep the permission wrapper.
 */
export const reportsRoutes: RouteObject[] = [
  { path: 'reports', element: <RequirePermission permission={['reports']}><ReportsPage /></RequirePermission> },
  { path: 'reports/new', element: <RequirePermission permission={['reports']}><ReportNewPage /></RequirePermission> },
  { path: 'reports/sql', element: <RequirePermission permission={['superlibrarian']}><ReportsSqlPage /></RequirePermission> },
  { path: 'reports/:id', element: <RequirePermission permission={['reports']}><ReportDetailPage /></RequirePermission> },
];
